/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DueDateDto } from './DueDateDto';
import {
    DueDateDtoFromJSON,
    DueDateDtoFromJSONTyped,
    DueDateDtoToJSON,
    DueDateDtoToJSONTyped,
} from './DueDateDto';
import type { ContactDto } from './ContactDto';
import {
    ContactDtoFromJSON,
    ContactDtoFromJSONTyped,
    ContactDtoToJSON,
    ContactDtoToJSONTyped,
} from './ContactDto';

/**
 * 
 * @export
 * @interface GetSpecialConditionsResponse
 */
export interface GetSpecialConditionsResponse {
    /**
     * ID of the selected bank account
     * @type {string}
     * @memberof GetSpecialConditionsResponse
     */
    bankAccountId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSpecialConditionsResponse
     */
    frequencyId: string;
    /**
     * 
     * @type {Date}
     * @memberof GetSpecialConditionsResponse
     */
    startDate: Date;
    /**
     * 
     * @type {DueDateDto}
     * @memberof GetSpecialConditionsResponse
     */
    dueDate: DueDateDto;
    /**
     * 
     * @type {string}
     * @memberof GetSpecialConditionsResponse
     */
    insuranceProjectCode: string;
    /**
     * Existing outstanding amount (excluding this project), in euros
     * @type {number}
     * @memberof GetSpecialConditionsResponse
     */
    existingOutstanding: number;
    /**
     * Existing outstanding amount from current insurer (excluding this project), in euros
     * @type {number}
     * @memberof GetSpecialConditionsResponse
     */
    existingOutstandingInsurer: number;
    /**
     * Current loan number
     * @type {string}
     * @memberof GetSpecialConditionsResponse
     */
    currentLoanNumber?: string;
    /**
     * 
     * @type {ContactDto}
     * @memberof GetSpecialConditionsResponse
     */
    bankContact: ContactDto;
    /**
     * 
     * @type {ContactDto}
     * @memberof GetSpecialConditionsResponse
     */
    insuranceContact?: ContactDto;
}

/**
 * Check if a given object implements the GetSpecialConditionsResponse interface.
 */
export function instanceOfGetSpecialConditionsResponse(value: object): value is GetSpecialConditionsResponse {
    if (!('frequencyId' in value) || value['frequencyId'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('insuranceProjectCode' in value) || value['insuranceProjectCode'] === undefined) return false;
    if (!('existingOutstanding' in value) || value['existingOutstanding'] === undefined) return false;
    if (!('existingOutstandingInsurer' in value) || value['existingOutstandingInsurer'] === undefined) return false;
    if (!('bankContact' in value) || value['bankContact'] === undefined) return false;
    return true;
}

export function GetSpecialConditionsResponseFromJSON(json: any): GetSpecialConditionsResponse {
    return GetSpecialConditionsResponseFromJSONTyped(json, false);
}

export function GetSpecialConditionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSpecialConditionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'bankAccountId': json['bankAccountId'] == null ? undefined : json['bankAccountId'],
        'frequencyId': json['frequencyId'],
        'startDate': (new Date(json['startDate'])),
        'dueDate': DueDateDtoFromJSON(json['dueDate']),
        'insuranceProjectCode': json['insuranceProjectCode'],
        'existingOutstanding': json['existingOutstanding'],
        'existingOutstandingInsurer': json['existingOutstandingInsurer'],
        'currentLoanNumber': json['currentLoanNumber'] == null ? undefined : json['currentLoanNumber'],
        'bankContact': ContactDtoFromJSON(json['bankContact']),
        'insuranceContact': json['insuranceContact'] == null ? undefined : ContactDtoFromJSON(json['insuranceContact']),
    };
}

export function GetSpecialConditionsResponseToJSON(json: any): GetSpecialConditionsResponse {
    return GetSpecialConditionsResponseToJSONTyped(json, false);
}

export function GetSpecialConditionsResponseToJSONTyped(value?: GetSpecialConditionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bankAccountId': value['bankAccountId'],
        'frequencyId': value['frequencyId'],
        'startDate': ((value['startDate']).toISOString()),
        'dueDate': DueDateDtoToJSON(value['dueDate']),
        'insuranceProjectCode': value['insuranceProjectCode'],
        'existingOutstanding': value['existingOutstanding'],
        'existingOutstandingInsurer': value['existingOutstandingInsurer'],
        'currentLoanNumber': value['currentLoanNumber'],
        'bankContact': ContactDtoToJSON(value['bankContact']),
        'insuranceContact': ContactDtoToJSON(value['insuranceContact']),
    };
}

